import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Download Icon from Figma
 * @link [Figma](https://www.figma.com/file/bUeKiC8YcV9PHrMlJAZUJG/Design-System?type=design&node-id=901-22995&mode=dev)
 * */
const DownloadIcon = props => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g className="stroke-current" strokeLinecap="round" strokeLinejoin="round" clipPath="url(#download-icon-path)"><path d="M11.5 9.109v.957a1.435 1.435 0 0 1-1.434 1.434H1.934A1.434 1.434 0 0 1 .5 10.066v-.957M6 9.054V.5M9.5 5.554 6 9.054l-3.5-3.5" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <defs><clipPath id="download-icon-path"><path fill="#fff" d="M0 0h12v12H0z" /></clipPath></defs>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <Svg width={12} height={12} {...props}>{t0}{t1}</Svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default DownloadIcon;